import Immutable, { Record } from 'immutable';

const OverallDevelopmentResultItemRecord = Record({
  typeCode: undefined,
  unitId: undefined,
  skillId: undefined,
  subSkillId: undefined,
  originalAbilityId: undefined,
  improvedAbilityId: undefined,
});

class OverallDevelopmentResultItem extends OverallDevelopmentResultItemRecord { }

const reviver = ([key, val]) => {
  if (! val) return [key, val];
  switch (key) {
    case 'unitId':
      return [key, `${val}`];
    case 'skillId':
      return [key, `${val}`];
    case 'subSkillId':
      return [key, `${val}`];
    case 'originalAbilityId':
      return [key, `${val}`];
    case 'improvedAbilityId':
      return [key, `${val}`];
    default:
      return [key, Immutable.fromJS(val)];
  }
};

OverallDevelopmentResultItem.create = (data) =>
  new OverallDevelopmentResultItem(data).mapEntries(reviver);

export default OverallDevelopmentResultItem;



// WEBPACK FOOTER //
// ./data/IndividualDevelopmentPlans/OverallDevelopment/result/items/model.js